require('./bootstrap');
require('overlayscrollbars/js/jquery.overlayScrollbars.min');
require('./bootstrap-tooltip-custom-class');
require('magnific-popup/dist/jquery.magnific-popup.min')
require('jquery.rateit/scripts/jquery.rateit.min');
require('lightslider/dist/js/lightslider.min');
require('slick-carousel/slick/slick.min');
require('./scripts');
